import { useSetting } from "@faire/retailer-visitor-shared/settings/__internal__/useSetting";
import { IThreeVariantXP } from "@faire/web-api--source/indigofair/settings/IThreeVariantXP";
import { LOGGED_OUT_PROMINENT_PRICE_PRODUCT_TILES_250317 } from "@faire/web-api--source/indigofair/settings/LOGGED_OUT_PROMINENT_PRICE_PRODUCT_TILES_250317";

import { useIsLoggedInRetailer } from "../lib/isLoggedInRetailer";

export const useSettingLoggedOutProductTilePrice = (): IThreeVariantXP => {
  const isLoggedInRetailer = useIsLoggedInRetailer();
  const variant = useSetting(
    LOGGED_OUT_PROMINENT_PRICE_PRODUCT_TILES_250317,
    IThreeVariantXP.Bucket.CONTROL
  );
  if (isLoggedInRetailer) {
    return IThreeVariantXP.Bucket.CONTROL;
  }
  return variant;
};

export const useIsLoggedOutProductTilePriceV3 = () => {
  const isLoggedOutProductTilePriceVariant =
    useSettingLoggedOutProductTilePrice();
  return (
    isLoggedOutProductTilePriceVariant === IThreeVariantXP.Bucket.VARIANT_3
  );
};
